/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SyncXeroInvoiceResult } from "./SyncXeroInvoiceResult";
import {
  SyncXeroInvoiceResultFromJSON,
  SyncXeroInvoiceResultFromJSONTyped,
  SyncXeroInvoiceResultToJSON,
  SyncXeroInvoiceResultToJSONTyped,
} from "./SyncXeroInvoiceResult";

/**
 *
 * @export
 * @interface CreateXeroInvoiceResponse
 */
export interface CreateXeroInvoiceResponse {
  /**
   *
   * @type {SyncXeroInvoiceResult}
   * @memberof CreateXeroInvoiceResponse
   */
  result: SyncXeroInvoiceResult;
}

/**
 * Check if a given object implements the CreateXeroInvoiceResponse interface.
 */
export function instanceOfCreateXeroInvoiceResponse(
  value: object,
): value is CreateXeroInvoiceResponse {
  if (!("result" in value) || value["result"] === undefined) return false;
  return true;
}

export function CreateXeroInvoiceResponseFromJSON(
  json: any,
): CreateXeroInvoiceResponse {
  return CreateXeroInvoiceResponseFromJSONTyped(json, false);
}

export function CreateXeroInvoiceResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateXeroInvoiceResponse {
  if (json == null) {
    return json;
  }
  return {
    result: SyncXeroInvoiceResultFromJSON(json["result"]),
  };
}

export function CreateXeroInvoiceResponseToJSON(
  json: any,
): CreateXeroInvoiceResponse {
  return CreateXeroInvoiceResponseToJSONTyped(json, false);
}

export function CreateXeroInvoiceResponseToJSONTyped(
  value?: CreateXeroInvoiceResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    result: SyncXeroInvoiceResultToJSON(value["result"]),
  };
}
